// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3PQH1","head":"ProcedureTableInfo_head__2CoWH"};